<template>
  <div class="animated fadeIn">
    <b-card>
      <iframe v-if="webMapPlotterUrl" :src="webMapPlotterUrl" style="width:100%;height:700px;"></iframe>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'dashboard',
  data() {
    return {
      webMapPlotterUrl: ''
    }
  },
  async created() {
    try {
      const response = await axios.get('/api/internal/getWebMapPlotterUrl')
      const configuredUrl = response && response.data && response.data.WebMapPlotterUrl

      if (configuredUrl) {
        this.webMapPlotterUrl = configuredUrl
      }
    } catch (error) {
      console.log(error)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue